const BASE_IMAGE_PATH = 'https://assets.homedepot-static.com/images/v1/';
export const COMPUTATION_FOR_CARPET = 0.16;
export const PAD_SF_RETAIL = 0.95;
export const FIELDSET_TITLE = 'Installed by Home Services';

export const ICON_URLS = {
  homeServices: `${BASE_IMAGE_PATH}home-services-icon.svg`,
  tools: `${BASE_IMAGE_PATH}tools-icon.svg`
};

export const samWhatToExpectList = [
  /* eslint-disable */
  'First, schedule your measure appointment online. We’ll come to your home to take precise digital measurements and make note of any special installation requirements.',
  'Based on these measurements and the carpet you choose, we’ll provide a project quote covering materials and installation.',
  'Our local, licensed installers will take care of everything, including basic furniture moving, new carpet installation, and disposal of your old carpet.'
    /* eslint-enable */
];